var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconreport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25004 5.41671V22.75H20.5834V24.9167H3.25004C2.05837 24.9167 1.08337 23.9417 1.08337 22.75V5.41671H3.25004ZM22.75 1.08337H7.58337C6.38087 1.08337 5.41671 2.04754 5.41671 3.25004V18.4167C5.41671 19.6084 6.39171 20.5834 7.58337 20.5834H22.75C23.9525 20.5834 24.9167 19.6192 24.9167 18.4167V3.25004C24.9167 2.05837 23.9417 1.08337 22.75 1.08337ZM22.75 18.4167H7.58337V3.25004H22.75V18.4167ZM11.9167 15.1667H8.66671V17.3334H11.9167V15.1667ZM16.25 15.1667H13V17.3334H16.25V15.1667ZM11.9167 11.9167H8.66671V14.0834H11.9167V11.9167ZM16.25 11.9167H13V14.0834H16.25V11.9167ZM11.9167 8.66671H8.66671V10.8334H11.9167V8.66671ZM16.25 8.66671H13V10.8334H16.25V8.66671Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconreport);
export default __webpack_public_path__ + "static/media/iconreport.fea3104470db6cd2322d9fc11ac11260.svg";
export { ForwardRef as ReactComponent };